module.exports = __webpack_public_path__ + "img/news5-2.13257f42.png";